<script setup>
import { ref, computed, onMounted } from 'vue';
import { useSubscription } from '../../composables/useSubscription';
import { ExclamationTriangleIcon, XMarkIcon } from '@heroicons/vue/24/outline';

const { getHighUsageResources, refreshUsage, plan } = useSubscription();
const dismissed = ref(false);

const resourceLabels = {
  events_created: 'events',
  emails_sent: 'emails',
  sms_sent: 'SMS messages',
  evaluation_ocr: 'OCR evaluations',
  attendees: 'attendee records',
  seats: 'team seats',
  offices: 'offices',
  campaigns: 'campaigns',
};

const highUsage = computed(() => {
  if (dismissed.value) return [];
  return getHighUsageResources();
});

const topResource = computed(() => highUsage.value[0] || null);

onMounted(() => {
  refreshUsage();
});
</script>

<template>
  <div
    v-if="topResource"
    class="bg-amber-50 border-b border-amber-200 px-4 py-2.5 flex items-center gap-3"
  >
    <ExclamationTriangleIcon class="w-5 h-5 text-amber-500 flex-shrink-0" />
    <p class="text-sm text-amber-800 flex-1">
      You've used <strong>{{ topResource.percent }}%</strong> of your {{ resourceLabels[topResource.resource] || topResource.resource }} this month
      ({{ topResource.current }} of {{ topResource.limit }}).
      <a href="/upgrade" class="font-semibold text-amber-900 underline hover:no-underline ml-1">
        Upgrade for more
      </a>
    </p>
    <button
      @click="dismissed = true"
      class="text-amber-400 hover:text-amber-600 transition-colors p-1"
    >
      <XMarkIcon class="w-4 h-4" />
    </button>
  </div>
</template>
